import classNames from "classnames";
import LoyaltyUserAvatar from "components/molecules/LoyaltyUserAvatar";
import LoyaltyCarouselContainer from "containers/organisms/LoyaltyCarouselContainer";
import LoyaltyRollbackButtonContainer from "containers/atoms/LoyaltyRollbackButtonContainer";
import { LoyaltyBoosterButtonContainer } from "containers/atoms/LoyaltyBoosterButtonContainer";
import "./styles.sass";

type LoyaltyUserInfoProps = {
  avatar?: string;
  className?: string;
  isLoading?: boolean;
};

export const LoyaltyUserInfo = ({
  avatar,
  className,
  isLoading,
}: LoyaltyUserInfoProps) => {
  const classNameContainer = classNames("LoyaltyUserInfo", className);

  return (
    <div className={classNameContainer}>
      <div className="LoyaltyUserInfo__inner">
        <LoyaltyUserAvatar avatar={avatar} isLoading={isLoading} />
        <LoyaltyCarouselContainer />
      </div>
      <div className="LoyaltyUserInfo__buttons">
        <LoyaltyRollbackButtonContainer className="LoyaltyUserInfo__buttonsInner" />
        <LoyaltyBoosterButtonContainer classNames="LoyaltyUserInfo__buttonsInner" />
      </div>
    </div>
  );
};
